module.exports = __webpack_public_path__ + "static/media/gift.28bd8be1.png";